function Transform() {
  this.x = 0;
  this.y = 0;
  this.scale = 1;
}

export default Transform



// WEBPACK FOOTER //
// ./src/lib/panzoom/lib/transform.js